<template>
    <div style="margin-top: 120px">
        <div class="container">
            <pageHeaderWrap>
                <pageHeaderUpperText>
                    <i class="icon-action lnr lnr-book"></i>
                    <span>Поиск взаимосвязей между ЮЛ / ФЛ</span>
                </pageHeaderUpperText>
            </pageHeaderWrap>
            <div class="relations-search">
                <div class="relations-search__input-form">
                    <div class="relations-search__form-block relations-search__form-block_buttons">
                        <btn @click="clearAllSuggestions">Очистить</btn>
                        <btn blue @click="searchConnections" :disabled="!(hintSuggestion.to && hintSuggestion.from)">Поиск</btn>
                    </div>
                    <div class="relations-search__form-block relations-search__form-block_input">
                        <div><b>ЮЛ / ФЛ 1: </b></div>
                        <div v-if="hintSuggestion.from" class="relations-search__form-block_hinted">
                            <i class="lnr lnr-cross blue-red-hover-text" @click="clearSuggestions('from')"></i>
                            <p v-if="hintSuggestion.from.name" class="single-long-string-nowrap">
                                <span>{{hintSuggestion.from.name}}</span>
                            </p>
                            <p v-if="hintSuggestion.from.inn">
                                <b>ИНН: </b>
                                <span>{{hintSuggestion.from.inn}}</span>
                            </p>
                        </div>
                        <div v-else>
                            <input @input="getSuggestions('from')" class="relations-search__input" type="text" placeholder="ЮЛ / ФЛ 1" v-model="from" autocomplete="off"/>
                            <i class="lnr lnr-cross blue-red-hover-text" @click="clearSuggestions('from')" v-if="from"></i>
                            <relationsSuggestions :suggestions="suggestionsFrom" :setSuggestion="(suggestion) => { setSuggestion(suggestion, 'from')}"/>
                        </div>
                    </div>
                    <div class="relations-search__form-block relations-search__form-block_input">
                        <div><b>ЮЛ / ФЛ 2: </b></div>
                        <div v-if="hintSuggestion.to" class="relations-search__form-block_hinted">
                            <i class="lnr lnr-cross blue-red-hover-text" @click="clearSuggestions('to')"></i>
                            <p v-if="hintSuggestion.to.name" class="single-long-string-nowrap">
                                <span>{{hintSuggestion.to.name}}</span>
                            </p>
                            <p v-if="hintSuggestion.to.inn">
                                <b>ИНН: </b>
                                <span>{{hintSuggestion.to.inn}}</span>
                            </p>
                        </div>
                        <div v-else>
                            <input @input="getSuggestions('to')" class="relations-search__input" type="text" placeholder="ЮЛ / ФЛ 2" v-model="to" autocomplete="off"/>
                            <i class="lnr lnr-cross blue-red-hover-text" @click="clearSuggestions('to')" v-if="to"></i>
                            <relationsSuggestions :suggestions="suggestionsTo" :setSuggestion="(suggestion) => { setSuggestion(suggestion, 'to')}"/>
                        </div>
                    </div>
                    <div class="relations-search__form-block rasporka">
                        <p style="float: left">
                            <span>Искать взаимосвязи на</span>
                            <span>расстоянии до</span>
                        </p>
                        <counter :getNumCb="getNumCb" :defaultNum="maxHops" style="float: right" />
                    </div>
                    <div style="text-align: right; margin-top: -15px">
                        <em v-if="maxHops <= 5">значимые взаимосвязи</em>
                        <em v-if="maxHops >= 6 && maxHops <= 7">малозначимые взаимосвязи</em>
                        <em v-if="maxHops >= 8">незначимые взаимосвязи</em>
                    </div>
                    <div class="relations-search__form-block relations-search__form-block_checkbox">
                        <label>
                            <input type="checkbox" v-model="all_links"/>
                            <span>Показать все возможные связи</span>
                        </label>
                    </div>
                </div>
                <div class="relations-search__network">
                    <shestirenka-loader v-if="relationsLoading" />
                    <relationsNetwork
                        v-if="!relationsLoading"
                        ref="relations-search-network"
                        :physics="true"
                        :relations="[hintSuggestion.from, hintSuggestion.to]"
                        printAndDownloadHeaderText="Поиск взаимосвязей между ЮЛ / ФЛ"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageMixin from '@/components/ui/Page.vue.js'
import btn from '@/components/ui/button.vue.js'
import relationsNetwork from '@/components/ui/relationsNetwork/relationsNetwork.vue'
import relationsSuggestions from '@/components/global/RelationsSearch/relationsSuggestions.vue'
import counter from '@/components/ui/counter.vue'
import shestirenkaLoader from '@/components/ui/shestirenkaLoader.vue'

export default {
    name: 'RelationsSearch',
    mixins: [PageMixin],
    components: {
        btn,
        relationsSuggestions,
        counter,
        relationsNetwork,
        shestirenkaLoader
    },
    methods: {
        clearAllSuggestions() {
            this.clearSuggestions('from')
            this.clearSuggestions('to')
            this.$store.commit('relations/setMaxHops', 5)
            this.$refs['relations-search-network'].generateNewNetwork(null)
        },
        getNumCb(num) {
            this.$store.commit('relations/setMaxHops', num)
        },
        setSuggestion(suggestion, direction) {
            this.$store.commit('relations/setSuggestion', { suggestion, direction })
        },
        clearSuggestions(direction) {
            this.$store.commit('relations/clearInputFieldData', direction)
            this.$store.commit('relations/setSuggestion', { direction, suggestion: null })
            this.$store.commit('relations/setSuggestions', { hints: [], direction })
        },
        getSuggestions(direction) {
            this.$store.dispatch('relations/getSuggestions', direction)
        },
        searchConnections() {
            if(this.hintSuggestion.to && this.hintSuggestion.from) {
                this.$store.dispatch('relations/searchRelations').then(e => {
                    if(e) {
                        this.$refs['relations-search-network'].generateNewNetwork(e)
                    }
                })
            }
        }
    },
    computed: {
        relationsLoading() { return this.$store.state.relations.relationsLoading },
        hintSuggestion() { return this.$store.state.relations.hintSuggestion },
        suggestionsFrom() { return this.$store.state.relations.suggestions.from },
        suggestionsTo() { return this.$store.state.relations.suggestions.to },
        from: {
            get() { return this.$store.state.relations.inputData.from },
            set(val) { this.$store.commit('relations/setInputFieldData', { direction: 'from', inputData: val }) }
        },
        to: {
            get() { return this.$store.state.relations.inputData.to },
            set(val) { this.$store.commit('relations/setInputFieldData', { direction: 'to', inputData: val }) }
        },
        maxHops: {
            get() { return this.$store.state.relations.maxHops },
            set(val) { this.$store.commit('relations/setMaxHops', val) }
        },
        all_links: {
            get() { return this.$store.state.relations.all_links },
            set(val) { this.$store.commit('relations/setAllLinks', val) }
        }
    }
}
</script>

<style lang="sass" scoped>
@use 'styles/global-variables.sass'
@use 'styles/font-face.sass'
@use 'styles/mobile.sass'

$max-desktop-resolution: 1440px
$min-desktop-resolution: 960px
// $tablet-resolution: 767px
$tablet-resolution: 850px
$max-mobile-resolution: 480px
$min-mobile-resolution: 320px

.rasporka
    &:after
        content: ""
        display: table
        clear: both

.container
    width: 1440px
    margin: 0 auto
    @media screen and (max-width: $max-desktop-resolution)
        width: 1280px
    @media screen and (max-width: 1280px)
        width: 1024px
    @media screen and (max-width: 1024px)
        width: $min-desktop-resolution
    @media screen and (max-width: $min-desktop-resolution)
        width: $tablet-resolution
    @media screen and (max-width: $tablet-resolution)
        width: calc(100% - 40px)
        margin-left: 20px
        margin-right: 20px
    @media screen and (max-width: $max-mobile-resolution)
        width: calc(100% - (15px*2))
        margin: 0 15px

@mixin plitka($bgc: #fafafa)
    position: relative
    padding: 15px
    background: $bgc
    color: #333
    border: 1px solid #ddd
    border-radius: 4px
    @media screen and (max-width: 480px)
        overflow: scroll

.single-long-string-nowrap
    white-space: nowrap
    text-overflow: ellipsis
    overflow: hidden

.relations-search
    padding-top: 40px
    position: relative
    min-height: 80vh
    display: flex
    justify-content: space-between
    margin-top: 50px
    padding-bottom: 50px
    &__input-form
        width: 30%
        min-width: 340px
        em
            font-style: italic
            color: #aaa
            font-size: 14px
    &__network
        width: 69%
        height: 540px
        +plitka
    @media screen and (max-width: 1280px)
        &__network
            width: 60%
        &__form-block_input
            flex-direction: column
        &__form-block i.lnr.lnr-cross
            top: 32px !important
    @media screen and (max-width: 850px)
        flex-direction: column
        &__network,
        &__input-form
            width: 100%
    &__form-block
        margin-bottom: 25px
        position: relative
        font-size: 14px
        font-weight: 400
        em
            font-style: italic
            color: #aaa
            font-size: 14px
        p
            margin: 0
            padding: 0
            padding-right: 30px
        i.lnr.lnr-cross
            position: absolute
            cursor: pointer
            right: 10px
            top: 12px
        &_hinted
            width: 300px
            i.lnr.lnr-cross
                top: 6px
        &_buttons
            display: flex
            justify-content: space-around
            button
                width: 150px
                height: 35px
                font-weight: 500
        &_input
            display: flex
            justify-content: space-between
            align-items: baseline
        &_checkbox
            input[type="checkbox"], span
                // display: inline-block
                vertical-align: middle
    &__input
        background: #fff
        border: 1px solid #3b5998
        box-shadow: inset 0px 0 3px #3b5998
        min-width: 340px
        width: 100%
        height: 40px
        padding: 1px 20px 0 10px
        border-radius: 5px
        white-space: nowrap
        text-overflow: ellipsis
        font-size: 16px
        &::placeholder
            text-align: center
            font-size: 16px !important
            font-style: italic !important
            color: #9e9e9e !important  
</style>